// Imports
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
Alpine.plugin(focus);
import "lazysizes";

window.Alpine = Alpine;
global.$ = global.jQuery = require('jquery');

import { mobileMenu } from "./lib/mobile-menu";
import { heroSlider } from "./lib/hero-carousel";
import { productsCarousel } from "./lib/products-carousel";
import { postsCarousel } from "./lib/posts-carousel";
import { zoomCarousel } from "./lib/zoom-carousel";
import { tooltips } from "./lib/tooltips";
import { validateForm } from "./lib/validate-form";
import { yotpo } from "./lib/yotpo";


// load alpine components
window.validateForm = validateForm;
Alpine.start();

var primaryNav = document.querySelector("#primary-nav");

document.addEventListener("DOMContentLoaded", () => {
    if (primaryNav) {
        primaryNav.classList.remove('hidden');
    }
    mobileMenu();
    heroSlider();
    productsCarousel();
    postsCarousel();
    zoomCarousel();
    tooltips();
    validateForm();
    yotpo();
});
